module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/eye_small.894ba27b.svg";